/* ============
 * Vuex Getters
 * ============
 *
 * All the getters that can be used
 * inside the store
 */

// Auth
export const isAuthenticated = state => state.auth.authenticated;
export const twoFactorVerification = state => state.auth.twoFactorVerification;
export const isInMaintenance = state => state.auth.maintenance;

export const clients = state => ({
  items: state.client.items,
  pagination: state.client.pagination,
});

export const allClients = state => state.client.all;
export const allClientOptions = state => state.client.options;
export const clientQuery = state => state.client.query;

// Profile
export const account = state => state.profile.account;
export const address = state => state.profile.address;
export const contact = state => state.profile.contact;
export const organizationSettings = state => state.profile.settings;
export const publicProfile = state => state.profile.publicProfile;
export const businessHours = state => state.profile.businessHours;
export const businessHourExceptions = state => state.profile.businessHourExceptions;

// Plan
export const allPlans = state => state.plan.plans;
export const chosenPlan = state => state.plan.chosenPlan;

// Organization Type
export const allOrganizationTypes = state => state.organizationType.organizationTypes;

// Client Group

export const paginatedClientGroups = state => ({
  items: state.clientGroup.items,
  pagination: state.clientGroup.pagination,
});

export const allClientGroups = state => ({
  all: state.clientGroup.all,
});

// client types
export const allClientTypes = state => state.clientTypes.all;

export const clientGroupItem = state => state.clientGroup.item;

//  client address types
export const addressTypes = state => state.addressTypes.addressTypes;
//  client contact types
export const contactTypes = state => state.contactTypes.contactTypes;

//  client contacts
export const currentClientContacts = state => state.client.clientContacts;

//  client address
export const currentClientAddresses = state => state.client.clientAddresses;

// Provider Group

export const allProviderGroups = state => ({
  all: state.providerGroup.all,
});

export const setDownloadProviderList = state => ({
  downloadExportList: state.providerGroup.downloadExportList,
});

export const setClientProvider = state => ({
  clientProvider: state.providerGroup.clientProvider,
});

// Material
export const paginatedMaterials = state => ({
  items: state.material.items,
  pagination: state.material.pagination,
});
export const allMaterials = state => state.material.all;
export const materialQuery = state => state.material.query;

// Material Types
export const allMaterialTypes = state => state.materialType.all;

// Batch
export const paginatedBatches = state => ({
  items: state.batch.items,
  pagination: state.batch.pagination,
});
export const allBatches = state => state.batch.all;
export const batchQuery = state => state.batch.query;

// Batch Logs
export const paginatedBatchLogs = state => ({
  items: state.batchLog.items,
  pagination: state.batchLog.pagination,
});
export const allBatchLogs = state => state.batchLog.all;
export const batchLogQuery = state => state.batchLog.query;

// Recipe
export const paginatedRecipes = state => ({
  items: state.recipe.items,
  pagination: state.recipe.pagination,
});
export const allRecipes = state => state.recipe.all;
export const recipeQuery = state => state.recipe.query;

// Recipe Types
export const allRecipeTypes = state => state.recipeType.all;

// Recipe Ingrediences
export const allRecipeIngrediences = state => state.recipeIngredience.all;

// Batch Ingrediences
export const allBatchIngrediences = state => state.batchIngredience.all;

// Recipe Procedures
export const allRecipeProcedures = state => state.recipeProcedure.all;

// Recipe Products
export const allRecipeProducts = state => state.recipeProduct.all;

// Equipment
export const paginatedEquipments = state => ({
  items: state.equipment.items,
  pagination: state.equipment.pagination,
});
export const allEquipments = state => state.equipment.all;
export const equipmentQuery = state => state.equipment.query;

// Product
export const paginatedProducts = state => ({
  items: state.product.items,
  pagination: state.product.pagination,
});

export const allProducts = state => state.product.all;
export const basicProducts = state => state.product.basic;
export const allProductTransactions = state => state.product.transactions;
export const allProductTransactionsV2 = state => state.product.transactionsV2;
export const productTransactionsV2 = state => ({
  items: state.product.paginateTransactionsV2.items,
  pagination: state.product.paginateTransactionsV2.pagination,
});

export const allProductPrices = state => state.product.productPrices;

export const productQuery = state => state.product.query;
export const productGrouping = state => state.product.query.grouping;

// Product Group
export const paginatedProductGroups = state => ({
  items: state.productGroup.items,
  pagination: state.productGroup.pagination,
});

export const allProductGroups = state => ({
  all: state.productGroup.all,
});

// Product Packaging
export const paginatedProductPackagings = state => ({
  items: state.productPackaging.items,
  pagination: state.productPackaging.pagination,
});

export const allProductPackagings = state => ({
  all: state.productPackaging.all,
});

// Packaging Materials
export const allPackagingMaterials = state => ({
  all: state.packagingMaterial.all,
});

// Packaging Types
export const allPackagingTypes = state => ({
  all: state.packagingType.all,
});

// Unit Types
export const allUnitTypes = state => ({
  all: state.unitType.all,
});

// Product Tag
export const paginatedProductTags = state => ({
  items: state.productTag.items,
  pagination: state.productTag.pagination,
});

export const allProductTags = state => ({
  all: state.productTag.all,
});

// Price Field
export const paginatedPriceFields = state => ({
  items: state.priceField.items,
  pagination: state.priceField.pagination,
});

export const allPriceFields = state => ({
  all: state.priceField.all,
});

// Product Types
export const allProductTypes = state => state.productType.all;

// Product Subtypes
export const allProductSubtypes = state => state.productSubtype.all;

// Product Recommendation
export const allProductRecommendations = state => state.productRecommendation.all;

// Producers
export const allProducers = state => state.producer.all;

export const allCountries = state => ({
  items: state.country.all,
  pagination: state.country.pagination,
});

// User dashboard widgets
export const availableWidgets = state => ({
  items: state.profile.availableWidgets,
});

export const widgets = state => ({
  items: state.profile.userWidgets,
});

export const bestClientsWidgets = state => ({
  items: state.profile.bestClientsWidgets,
});

export const waitingProcessedWidgets = state => ({
  items: state.profile.waitingProcessedWidgets,
});

export const waitingDeliveredWidgets = state => ({
  items: state.profile.waitingDeliveredWidgets,
});

export const orderReceivedWidgets = state => ({
  items: state.profile.orderReceivedWidgets,
});

export const revenueWidgets = state => ({
  items: state.profile.revenueWidgets,
});

export const popularProductsWidgets = state => ({
  items: state.profile.popularProductsWidgets,
});

export const soldProductsWidgets = state => ({
  items: state.profile.soldProductsWidgets,
});

// Site languages
export const allLanguages = state => ({
  items: state.siteLanguages.all,
});

export const allCities = state => ({
  items: state.city.all,
  pagination: state.city.pagination,
});

export const allMunicipalities = state => ({
  items: state.municipality.all,
  pagination: state.municipality.pagination,
});

export const allPostals = state => ({
  items: state.postal.all,
  pagination: state.postal.pagination,
});

export const businessDays = state => state.businessDay.all;

export const allTaxes = state => ({
  all: state.tax.all,
  pagination: state.tax.pagination,
});

export const allProductDeposits = state => ({
  all: state.productDeposit.all,
});

export const allDepositSystems = state => ({
  all: state.depositSystem.all,
});

// Orders
export const paginatedOrders = state => ({
  items: state.order.items,
  pagination: state.order.pagination,
});

export const allOrders = state => ({
  all: state.order.all,
});

export const orderQuery = state => state.order.query;

export const currentOrder = state => state.order.currentOrder;
export const orderEvents = state => state.order.events;

export const orderTypes = state => state.order.types;

// Bills
export const paginatedBills = state => ({
  items: state.bill.items,
  pagination: state.bill.pagination,
});
export const billStatuses = state => state.bill.statuses;
export const billTypes = state => state.bill.types;
export const currentBill = state => state.bill.currentBill;
export const billQuery = state => state.bill.query;

export const allCreditNoteReasons = state => state.creditNoteReason.all;
export const currentCreditNoteReason = state => state.creditNoteReason.current;

// Order Products
export const allOrderProducts = state => state.orderProduct.all;

export const allBillProducts = state => state.billProduct.all;
// Credit Note Products
export const allCreditNoteProducts = state => state.creditNoteProduct.all;

export { allClients as default };

// Edi Orders
export const paginatedEdiOrders = state => ({
  items: state.ediOrder.items,
  pagination: state.ediOrder.pagination,
});

export const allEdiOrders = state => ({
  all: state.ediOrder.all,
});

export const currentEdiOrder = state => state.ediOrder.currentEdiOrder;

// Edi Order Items
export const allEdiOrderItems = state => state.ediOrderItem.all;

// Message Template Types
export const allMessageTemplateTypes = state => state.messageTemplateType.types;

// Accounting Providers
export const allAccountingProviders = state => state.accountingProvider.all;

// Chart of accounts
export const allChartOfAccounts = state => ({
  all: state.chartOfAccounts.all,
});

// Campaign
export const paginatedCampaigns = state => ({
  items: state.campaign.items,
  pagination: state.campaign.pagination,
});
export const campaignTypes = state => state.campaign.types;

// Sidebar
export const innerSidebar = state => state.sidebar.innerSidebar;
export const innerSidebarState = state => state.sidebar.innerSidebarState;
export const innerSidebarDisabled = state => state.sidebar.innerSidebarDisabled;

// Modal
export const modalState = state => state.modal.modalState;
export const modalContent = state => state.modal.modalContent;
export const modalSize = state => state.modal.modalSize;
export const modalClass = state => state.modal.modalClass;
export const modalCloseOnClick = state => state.modal.modalCloseOnClick;
export const modalShowClose = state => state.modal.modalShowClose;
export const modalCloseOnPressEscape = state => state.modal.modalCloseOnPressEscape;
export const modalProps = state => state.modal.modalProps;
export const modalButtonLoading = state => state.modal.modalButtonLoading;

// Supplier
export const allSuppliers = state => ({
  items: state.supplier.all,
  pagination: state.supplier.paginations,
});
export const paginateSuppliers = state => ({
  items: state.supplier.items,
  pagination: state.supplier.pagination,
});
export const currentSupplier = state => state.supplier.currentSupplier;

// Warehouses
export const allWarehouses = state => ({
  items: state.warehouse.all,
  pagination: state.warehouse.paginations,
});
export const paginateWarehouses = state => ({
  items: state.warehouse.items,
  pagination: state.warehouse.pagination,
});
export const currentWarehouse = state => state.warehouse.currentWarehouse;
// export const currentWarehouseProducts = state => state.warehouse.products;
export const paginateWarehouseProducts = state => ({
  items: state.warehouse.products.items,
  pagination: state.warehouse.products.pagination,
});
export const allWarehouseTransactions = state => state.warehouse.transactions;

// TransactionsV2
export const allWarehouseTransactionsV2 = state => state.warehouse.transactionsV2All;
export const paginateWarehouseTransactionsV2 = state => ({
  items: state.warehouse.transactionsV2.items,
  pagination: state.warehouse.transactionsV2.pagination,
});

// UNIT OF MEASURES
export const allUnitOfMeasures = state => ({
  items: state.unitOfMeasure.all,
});
export const paginateUnitOfMeasures = state => ({
  items: state.unitOfMeasure.items,
  pagination: state.unitOfMeasure.pagination,
});
export const currentUnitOfMeasure = state => state.unitOfMeasure.currentUnitOfMeasure;

// STOCKS
export const allStocks = state => ({
  items: state.stock.all,
  pagination: state.stock.paginations,
});
export const paginateStocks = state => ({
  items: state.stock.items,
  pagination: state.stock.pagination,
});
export const currentStock = state => state.stock.currentStock;
export const currentStockProducts = state => state.stock.stockProducts;
export const currentSelectedWarehouse = state => state.stock.warehouseId;
export const currentStockProductsCustom = state => state.stock.stockProductsCustom;

// STOCKS
export const allAdjustments = state => ({
  items: state.adjustment.all,
  pagination: state.adjustment.paginations,
});
export const paginateAdjustments = state => ({
  items: state.adjustment.items,
  pagination: state.adjustment.pagination,
});
export const currentAdjustment = state => state.adjustment.currentAdjustment;

// PURCHASE
export const allPurchases = state => ({
  items: state.purchase.all,
  pagination: state.purchase.paginations,
});
export const paginatePurchases = state => ({
  items: state.purchase.items,
  pagination: state.purchase.pagination,
});
export const currentPurchase = state => state.purchase.currentPurchase;
export const purchaseStatuses = state => state.purchase.statuses;

// VIEW
export const getView = state => state.view.view;
export const getOrderViewType = state => state.view.orderViewType;

// Shipping Providers
export const allShippingProviders = state => state.shippingProvider.all;
export const currentShippingProvider = state => state.shippingProvider.currentshippingProvider;

// productFlows
export const allproductFlows = state => ({
  items: state.productFlow.all,
  pagination: state.productFlow.paginations,
});
export const paginateproductFlows = state => ({
  items: state.productFlow.items,
  pagination: state.productFlow.pagination,
});

// PRODUCT FLOW
export const currentproductFlow = state => state.productFlow.currentproductFlow;
export const allproductFlowOrders = state => state.productFlow.orders;

// EXCISE
export const allExciseGroups = state => state.exciseGroup.all;
export const allExcisePackagingGroups = state => state.exciseGroup.packaging;
export const allExciseBasicGroups = state => state.exciseGroup.basic;
export const allAdditionalCode = state => state.additionalCode.all;

// ORGANIZATION MEMBERS
export const allOrganizationMembers = state => state.organizationMember.all;
export const allOrganizationMemberProductBusinessHours = state => state.organizationMemberProductBusinesshour.all;
export const allOrganizationMemberBookings = state => state.organizationMemberBooking.all;

// MODULES
export const allModules = state => state.modules.all;
// TRANSACTION TYPE
export const allTransactionTypes = state => state.transactionType.transactionTypes;

// TRANSFER
export const allTransfers = state => ({
  items: state.transfer.all,
  pagination: state.transfer.paginations,
});
export const paginateTransfers = state => ({
  items: state.transfer.items,
  pagination: state.transfer.pagination,
});
export const currentTransfer = state => state.transfer.currentTransfer;

// LICENSE
export const allLicenses = state => state.license.all;
export const allLicenseTypes = state => state.licenseType.all;
export const allLicensePermits = state => state.licensePermit.all;
export const allLicenseGroups = state => state.licenseGroup.all;
export const allLicensePermitGroups = state => state.licensePermitGroup.all;
export const allLicensePermitTypes = state => state.licensePermitType.all;

// Excise Periods
export const paginatedExcisePeriods = state => ({
  items: state.excisePeriod.items,
  pagination: state.excisePeriod.pagination,
});

export const allExcisePeriods = state => ({
  all: state.excisePeriod.all,
});

// SubscribeList
export const allSubscriberList = state => ({
  items: state.subscriberList.all,
});
export const paginatedSubscriberList = state => ({
  items: state.subscriberList.items,
  pagination: state.subscriberList.pagination,
});

export const subscriberList = state => ({
  current: state.subscriberList.current,
});
export const modifiedClientGroup = state => ({
  items: state.subscriberList.modifiedClientGroup,
});
export const cancelClientGroupAdd = state => ({
  items: state.subscriberList.cancelClientGroupAdd,
});

// Subscriber
export const subscriber = state => ({
  items: state.subscriber.all,
});
export const paginatedSubscriber = state => ({
  items: state.subscriber.items,
  pagination: state.subscriber.pagination,
});
// Package unit types
export const allPackageUnitTypes = state => ({
  all: state.packageUnitType.all,
});

// Packages
export const deliveryPackages = state => ({
  all: state.pckg.all,
});

// Packages
export const allPackageOrderProducts = state => ({
  all: state.packageOrderProduct.all,
});

// app toast response
export const toastResp = state => ({
  items: state.profile.userAppToast.data,
});

// latest app version
export const latestAppVersion = state => ({
  items: state.profile.userAppVersion.data,
});

// Partners
export const allPartners = state => state.partner.all;

// Order pickups
export const paginatedOrderPickups = state => ({
  items: state.orderPickup.items,
  pagination: state.orderPickup.pagination,
});

export const allOrderPickups = state => ({
  all: state.orderPickup.all,
});

export const orderPickupQuery = state => state.orderPickup.query;

export const currentOrderPickup = state => state.orderPickup.currentOrderPickup;
export const orderPickupEvents = state => state.orderPickup.events;

export const orderPickupTypes = state => state.orderPickup.types;

// Payment methods
export const paymentMethods = state => state.paymentMethods.paymentMethods;

// Language
export const languages = state => ({
  all: state.language.all,
});

// Currency
export const currencies = state => ({
  all: state.currency.all,
});

// Project
export const projects = state => ({
  items: state.project.items,
  pagination: state.project.pagination,
});
export const allProjects = state => state.project.all;

// Inventory bridge handoff (Phase E/F)
export const bridgeHandoff = state => state.bridgeHandoff.state;
export const stockMutationsHandedOff = state =>
  !!(state.bridgeHandoff.state && state.bridgeHandoff.state.stock_mutations_handed_off);
export const stockDecommissioned = state =>
  !!(state.bridgeHandoff.state && state.bridgeHandoff.state.stock_decommissioned);
export const inventoryAppUrl = state =>
  (state.bridgeHandoff.state && state.bridgeHandoff.state.inventory_app_url) || '';



// WEBPACK FOOTER //
// ./src/app/store/getters.js